/** Öffentliche Routen ohne Session. Legacy-Pfade leiten nur weiter. */
const ANONYMOUS_OK = new Set([
  "/login",
  "/register",
  "/auth/forgot",
  "/auth/recovery",
  "/invite/accept",
  "/resetPassword",
  "/setPassword",
]);

/**
 * Einzige Redirect-Entscheidung der App.
 * Recovery und Einladung bleiben auch mit Session erreichbar,
 * damit Passwort setzen bzw. Annehmen nicht nach /home springt.
 */
export function normalizeAuthPath(pathname: string): string {
  const path = pathname.split("?")[0]?.split("#")[0] ?? "/";
  if (path.length > 1 && path.endsWith("/")) return path.slice(0, -1);
  return path || "/";
}

export function authGateDecision(
  pathname: string,
  hasSession: boolean,
): "/login" | "/home" | null {
  const path = normalizeAuthPath(pathname);
  if (!hasSession) {
    if (path === "/") return "/login";
    if (ANONYMOUS_OK.has(path)) return null;
    return "/login";
  }
  if (
    path === "/" ||
    path === "/login" ||
    path === "/register" ||
    path === "/auth/forgot" ||
    path === "/resetPassword"
  ) {
    return "/home";
  }
  return null;
}
